import React from 'react';
import { connect } from 'react-redux';
import { requestFetchSubscription, notify, setSubscriptions, push } from 'actions';
import { Container, LoadingSpinner, SubscriptionDetailsView } from 'components';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router';
import { cancelSubscription } from 'api';

class SubscriptionsContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      canceling: false
    };

    this.handleViewSubscription = this.handleViewSubscription.bind(this);
  }

  handleViewSubscription() {
    this.props.push('/settings/subscriptions/view-details');
  }
  componentWillMount() {
    const { user } = this.props.users;
    const fetch_options = { filters: { account: user.owner_account || user._id } };
    this.props.requestFetchSubscription(fetch_options);
  }

  render() {
    const { subscriptions, fetching_subscription } = this.props.subscriptions;
    return fetching_subscription ? (
      <LoadingSpinner />
    ) : (
      <Container title='Subscriptions' addLargeWidthPadding>
        <div className='subscriptions-container'>
          <Panel bsStyle='success' header='Subscriptions'>
            {subscriptions.length > 0 ? (
              <SubscriptionDetailsView />
            ) : (
              <p>Your account is not subscribed to any plans. <Link to='/settings/subscriptions/wizard'>Click here</Link> to enable new features and maximize your experience</p>
            )}
          </Panel>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({ subscriptions, users }) => ({ subscriptions, users });

export default connect(mapStateToProps, { requestFetchSubscription, notify, setSubscriptions, push })(SubscriptionsContainer);



// WEBPACK FOOTER //
// ./src/browser/components/settings/subscriptions/subscriptions-container.js